import React from 'react';
import { Tbody as ChakraTbody } from '@chakra-ui/react';

export const Tbody = props => <ChakraTbody {...props} />;
